import { render, staticRenderFns } from "./PostCreateModal.vue?vue&type=template&id=21c85aab&"
import script from "./PostCreateModal.vue?vue&type=script&lang=js&"
export * from "./PostCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports